import React from "react";

const RightArrowBlueIcon = ({width=15,height=15}) => {
  return (
    <svg width={width} height={height} cursor="pointer" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.7812 5.15625L13.125 7.5M13.125 7.5L10.7812 9.84375M13.125 7.5H1.875" stroke="#2158D0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>    
  );
};

export default RightArrowBlueIcon;
